"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var WebsiteEditor = function WebsiteEditor(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: '0 0 512 512'
  }, props), /*#__PURE__*/_react["default"].createElement('g', null, /*#__PURE__*/_react["default"].createElement('g', null, /*#__PURE__*/_react["default"].createElement('g', null, /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M0,28.239v81.057v374.466h512V109.294V28.239H0z M497,468.76H15V109.294h482V468.76z M497,94.296H15V43.239h482V94.296z'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M45.917,89.263c10.998,0,19.945-8.947,19.945-19.945c0.001-10.998-8.947-19.945-19.945-19.945\r S25.972,58.32,25.972,69.317S34.919,89.263,45.917,89.263z M45.917,64.374c2.727,0,4.945,2.218,4.945,4.945\r c0.001,2.726-2.218,4.945-4.945,4.945s-4.945-2.218-4.945-4.945C40.972,66.591,43.19,64.374,45.917,64.374z'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M103.418,89.263c10.998,0,19.945-8.947,19.945-19.945c0.001-10.998-8.947-19.945-19.945-19.945\r c-10.998,0-19.945,8.947-19.945,19.945S92.42,89.263,103.418,89.263z M103.418,64.374c2.727,0,4.945,2.218,4.945,4.945\r c0.001,2.726-2.218,4.945-4.945,4.945c-2.727,0-4.945-2.218-4.945-4.945C98.473,66.591,100.691,64.374,103.418,64.374z'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M160.92,89.263c10.998,0,19.945-8.947,19.945-19.945c0-10.998-8.948-19.945-19.945-19.945\r c-10.998,0-19.945,8.947-19.945,19.945S149.922,89.263,160.92,89.263z M160.92,64.374c2.727,0,4.945,2.218,4.945,4.945\r c0,2.726-2.219,4.945-4.945,4.945c-2.727,0-4.945-2.218-4.945-4.945C155.975,66.591,158.193,64.374,160.92,64.374z'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M326.852,89.263h128.597c10.997,0,19.944-8.947,19.944-19.945c0-3.031-0.664-5.944-1.975-8.662\r c-3.309-6.854-10.362-11.283-17.97-11.283H326.852c-10.998,0-19.945,8.947-19.945,19.945S315.854,89.263,326.852,89.263z\r M326.852,64.374h128.597c1.917,0,3.626,1.074,4.46,2.802c0.321,0.667,0.484,1.388,0.484,2.144c0,2.725-2.218,4.944-4.945,4.944\r H326.852c-2.727,0-4.945-2.218-4.945-4.945C321.907,66.591,324.126,64.374,326.852,64.374z'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M433.105,437.281c10.497,0,20.276-5.198,26.16-13.907c3.528-5.223,5.393-11.325,5.393-17.646v-4.954v-15V225.536v-16.583\r v-10.964l-31.553-65.531l-31.553,65.531v10.964v16.583v160.237v15v4.954C401.553,423.125,415.707,437.281,433.105,437.281z\r M416.553,201.412l16.553-34.377l16.553,34.377v0.471l-16.553-7.803l-16.553,7.803V201.412z M425.606,214.198v96.923h15v-96.923\r l9.053,4.267v167.308h-33.105V218.465h-0.001L425.606,214.198z M416.553,400.773h33.105v0v4.954c0,3.318-0.976,6.517-2.821,9.249\r c-3.091,4.573-8.224,7.304-13.731,7.304c-9.127,0-16.553-7.425-16.553-16.553V400.773z'
  }), /*#__PURE__*/_react["default"].createElement('rect', {
    x: '425.61',
    y: '330.729',
    width: '15',
    height: '16.356'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M224.5,129.257H38.417v186.083H224.5V129.257z M209.5,300.339H53.417V144.257H209.5V300.339z'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M224.5,345.927H38.417v94.691H224.5V345.927z M209.5,425.619H53.417v-64.691H209.5V425.619z'
  }), /*#__PURE__*/_react["default"].createElement('rect', {
    x: '260.33',
    y: '129.26',
    width: '98.36',
    height: '15'
  }), /*#__PURE__*/_react["default"].createElement('rect', {
    x: '260.33',
    y: '184.249',
    width: '98.36',
    height: '15'
  }), /*#__PURE__*/_react["default"].createElement('rect', {
    x: '260.33',
    y: '239.239',
    width: '98.36',
    height: '15'
  }), /*#__PURE__*/_react["default"].createElement('rect', {
    x: '260.33',
    y: '345.93',
    width: '98.36',
    height: '15'
  }), /*#__PURE__*/_react["default"].createElement('rect', {
    x: '260.33',
    y: '400.919',
    width: '98.36',
    height: '15'
  })))));
};
/* eslint-enable */
var _default = WebsiteEditor;
exports["default"] = _default;